import React from 'react';
import V4Minimalist from './versions/v4-minimalist';

function App() {
  return <V4Minimalist />;
}

export default App;
